'use client'

import { Button } from '@/core/ui/atoms/button'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'
import { useCookiesStore } from './cookies'

export const CookiesBanner: React.FC = () => {
  const { cookiesConsented, acceptCookies } = useCookiesStore()
  const [isShown, setIsShown] = useState(false)
  const t = useTranslations()

  useEffect(() => {
    const timeout = !cookiesConsented
      ? window.setTimeout(() => setIsShown(true), 4000)
      : null

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [cookiesConsented])

  if (!isShown) {
    return null
  }

  return (
    <div className='fixed start-0 bottom-0 z-50 flex w-auto flex-col gap-2 rounded-md bg-white p-5 shadow-2xl shadow-black transition-all duration-500 min-[28rem]:start-5 min-[28rem]:bottom-5 min-[28rem]:max-w-md'>
      <h4 className='text-lg font-semibold'>{t('cookies.title')}</h4>
      <p className='text-sm'>{t('cookies.desc')}</p>
      <div className='mt-2 flex flex-col gap-2 min-[28rem]:flex-row min-[28rem]:items-center'>
        <Button
          variant='outlined'
          color='mountain-bluebird'
          onClick={() => {
            setIsShown(false)
            acceptCookies()
          }}
          className='flex-1 min-[28rem]:w-44'
        >
          {t('cookies.acceptEssentials')}
        </Button>
        <Button
          color='mountain-bluebird'
          onClick={() => {
            setIsShown(false)
            acceptCookies()
          }}
          className='flex-1 min-[28rem]:w-44'
        >
          {t('cookies.accept')}
        </Button>
      </div>
    </div>
  )
}

export default CookiesBanner
